import { Injectable } from '@angular/core';

Injectable();
export abstract class LandingPage {
    abstract navigate(): any;
}
